// Copyright © 2022 The Things Industries B.V.

export default Object.freeze({
  DEFAULT_PORT: 195,
  DEFAULT_PACKAGE_NAME: 'azure-iot-central',
})
